module.exports = __webpack_public_path__ + "static/media/printing-services-img19.b68af20e.jpg";